import { useSearchParams } from 'react-router-dom';
import { LoadingOverlay } from '@sunrun/experience-ui-components';
import { useFeatureFlagEnabled } from '@sunrun/sales-experience-shared/react-feature-flags';
import { getNewDashboardOrgType } from 'helpers/repTypeHelper';
import { useHybridToken } from 'providers/Auth';
import { useUserProfile } from 'providers/UserProfile';
// eslint-disable-next-line import/no-restricted-paths
import { Overview } from 'components/pages/Overview';
// eslint-disable-next-line import/no-restricted-paths
import { NewDashboard } from 'components/pages/NewDashboard';
import { LogHoursReminderModal } from 'components/organisms/LogHoursReminderModal';
import { RecheckVerificationPrompt } from 'components/organisms/RecheckVerificationPrompt';
import { FEATURE_FLAGS } from 'constants/FeatureFlags';

const OverviewRoute = () => {
  const [searchParams] = useSearchParams();
  const { userProfile } = useUserProfile();
  const { hybridToken } = useHybridToken();
  const newDashboardEnabled = useFeatureFlagEnabled(
    FEATURE_FLAGS.NEW_DASHBOARD,
  );
  const splatRoleEnabled = useFeatureFlagEnabled(
    FEATURE_FLAGS.SPLAT_ROLE_ENABLED,
  );
  const jwt = searchParams.get('jwt');
  const email = searchParams.get('email');
  const prereqsReady = jwt && email;

  const awaitingProfileForFlags =
    Boolean(hybridToken) && !userProfile?.contactId;
  const orgType = getNewDashboardOrgType(userProfile);
  const flagsOk = newDashboardEnabled && splatRoleEnabled;
  const shouldSeeNewDashboard = orgType === 'STREET' || flagsOk;

  if (awaitingProfileForFlags || (!prereqsReady && shouldSeeNewDashboard)) {
    return <LoadingOverlay message="Loading..." />;
  }

  return (
    <>
      <RecheckVerificationPrompt />
      <LogHoursReminderModal />
      {shouldSeeNewDashboard ? <NewDashboard /> : <Overview />}
    </>
  );
};

export { OverviewRoute };
